import moment from 'moment'
import { axios } from '../../../plugins/axios'
import Vue from 'vue'
import EvaluacionDisciplinaAdministrativaAdapter from '@modules/evaluacion-desempeño/application/adapters/EvaluacionDisciplinaAdministrativa.adapter'

export default {
  namespaced: true,

  state: {
    disciplinaAdministrativa: [],
    selectedDisciplinaAdministrativa: null,
  },

  getters: {
    getDisciplinaAdministrativa: (state) => {
      return state.disciplinaAdministrativa
    },
    getSelectedDisciplinaAdministrativa: (state) => {
      return state.selectedDisciplinaAdministrativa
    },
  },

  mutations: {
    SET_DISCIPLINA_ADMINISTRATIVA(state, disciplinaAdministrativa) {
      Vue.set(state, 'disciplinaAdministrativa', disciplinaAdministrativa)
    },

    SET_SELECTED_DISCIPLINA_ADMINISTRATIVA(state, disciplinaAdministrativa) {
      Vue.set(state, 'selectedDisciplinaAdministrativa', disciplinaAdministrativa)
    },
  },

  actions: {
    fetchDisciplinaAdministrativa: async function ({ commit }, idPersonal) {
      await axios
        .get('/PoliciaCuadrantes/DesarrolloPolicial/personal/' + idPersonal + '/disciplinaAdministrativa')
        .then((response) => {
          commit(
            'SET_DISCIPLINA_ADMINISTRATIVA',
            response.data.data.map((evaluacionDto) => {
              return EvaluacionDisciplinaAdministrativaAdapter.toDomain(evaluacionDto)
            })
          )
        })
        .catch((error) => console.log(error))
    },

    saveDisciplinaAdministrativa: async function ({ commit }, disciplinaAdministrativa) {
      await axios
        .post(
          '/PoliciaCuadrantes/DesarrolloPolicial/personal/' +
            disciplinaAdministrativa.fk_idPersonal +
            '/disciplinaAdministrativa',
          disciplinaAdministrativa
        )
        .then((response) => {
          //console.log('OK')
        })
        .catch((error) => console.log(error))
    },

    updateDisciplinaAdministrativa: async function (context, disciplinaAdministrativa) {
      disciplinaAdministrativa.estimulos.forEach((estimulo) => {
        estimulo.fecha = moment(estimulo.fecha).format(this.API_DATE_FORMAT)
      })

      disciplinaAdministrativa.reconocimientos.forEach((reconocimiento) => {
        reconocimiento.fecha = moment(reconocimiento.fecha).format(this.API_DATE_FORMAT)
      })

      disciplinaAdministrativa.actasAdministrativas.forEach((acta) => {
        acta.fecha = moment(acta.fecha).format(this.API_DATE_FORMAT)
      })

      await axios
        .put(
          '/PoliciaCuadrantes/DesarrolloPolicial/personal/' +
            disciplinaAdministrativa.fk_idPersonal +
            '/disciplinaAdministrativa/' +
            disciplinaAdministrativa.id,
          disciplinaAdministrativa
        )
        .then((response) => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Evaluación guardada correctamente.', {
            root: true,
          })
        })
        .catch((error) => console.log(error))
    },

    updateEstatus: async function (context, disciplinaAdministrativa) {
      await axios
        .put(
          '/PoliciaCuadrantes/DesarrolloPolicial/personal/' +
            disciplinaAdministrativa.fk_idPersonal +
            '/disciplinaAdministrativa/' +
            disciplinaAdministrativa.id +
            '/estatus',
          { fk_idCatEstatusEvaluacion: disciplinaAdministrativa.fk_idCatEstatusEvaluacion }
        )
        .then((response) => {})
        .catch((error) => console.log(error))
    },
  },
}
